import { useApisMembersAiChatRoomsAiEmployeeConversationsCreate } from "~/hooks";

import { ApiMembersAiChatRoomsAiEmployeeConversationsMutateResponseType } from "~/domains";

type ApiRequestType = {
  message: string;
  aiChatRoomId: string;
  onSuccess?: (
    response: ApiMembersAiChatRoomsAiEmployeeConversationsMutateResponseType,
  ) => void;
};

type ReturnType = {
  aiChatConversationRequest: ({
    message,
    aiChatRoomId,
    onSuccess,
  }: ApiRequestType) => void;
  isEmployeeSubmitting: boolean;
};

export const useAiChatConversationRequest = (): ReturnType => {
  const {
    mutate: postConversationRequest,
    isLoading: isPostConversationSubmitting,
  } = useApisMembersAiChatRoomsAiEmployeeConversationsCreate();

  const aiChatConversationRequest = ({
    message,
    aiChatRoomId,
    onSuccess,
  }: ApiRequestType) => {
    postConversationRequest(
      {
        aiChatRoomId,
        body: {
          message,
        },
      },
      {
        onSuccess: (conversationResponse) => {
          onSuccess && onSuccess(conversationResponse);
        },
      },
    );
  };

  return {
    aiChatConversationRequest,
    isEmployeeSubmitting: isPostConversationSubmitting,
  };
};
